import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { LogOut, LayoutDashboard, Menu, X } from "lucide-react";
import { useState } from "react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-xl border-b border-emerald-950/10 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center group" data-testid="nav-logo">
          <img src="/logo.jpg" alt="Solar Stars LLC" className="h-12 w-auto object-contain group-hover:scale-105 transition-transform" />
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-slate-600">
          <Link to="/#how" className="hover:text-emerald-700 transition-colors" data-testid="nav-how">How It Works</Link>
          <Link to="/#pricing" className="hover:text-emerald-700 transition-colors" data-testid="nav-pricing">Pricing</Link>
          <Link to="/#story" className="hover:text-emerald-700 transition-colors" data-testid="nav-story">Our Story</Link>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Button variant="ghost" onClick={() => navigate(user.role === "admin" ? "/admin" : "/dashboard")} data-testid="nav-dashboard-btn" className="gap-2">
                <LayoutDashboard className="w-4 h-4" /> {user.role === "admin" ? "Dispatch" : "Dashboard"}
              </Button>
              <Button onClick={handleLogout} variant="outline" data-testid="nav-logout-btn" className="gap-2 rounded-full">
                <LogOut className="w-4 h-4" /> Sign Out
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" onClick={() => navigate("/login")} data-testid="nav-login-btn">Sign In</Button>
              <Button onClick={() => navigate("/book")} data-testid="nav-book-btn" className="rounded-full bg-emerald-700 hover:bg-emerald-800 shadow-md">
                Book a Cleaning
              </Button>
            </>
          )}
        </div>

        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-100 bg-white px-4 py-4 flex flex-col gap-2" data-testid="nav-mobile-menu">
          {user ? (
            <>
              <Button variant="ghost" className="justify-start" onClick={() => { setOpen(false); navigate(user.role === "admin" ? "/admin" : "/dashboard"); }}>
                {user.role === "admin" ? "Dispatch" : "Dashboard"}
              </Button>
              <Button variant="outline" className="justify-start" onClick={handleLogout}>Sign Out</Button>
            </>
          ) : (
            <>
              <Button variant="ghost" className="justify-start" onClick={() => { setOpen(false); navigate("/login"); }}>Sign In</Button>
              <Button className="bg-emerald-700 hover:bg-emerald-800" onClick={() => { setOpen(false); navigate("/book"); }}>Book a Cleaning</Button>
            </>
          )}
        </div>
      )}
    </header>
  );
}
